import React from 'react';
import { Box, Typography } from '@drone-js/core';
import { ReviewCardProps } from 'component/page/detail/Review/Review.selectors';
import ReviewCardTitle from 'component/page/detail/Review/ReviewCard/ReviewCardTitle';
import AgodaMarkdown from 'component/common/AgodaMarkdown/AgodaMarkdown';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import {
    ActivitiesMiniReviewContentRevealEventActivitiesFieldsV1,
    ActivitiesReviewCardClickEventActivitiesFieldsV1,
    ActivitiesReviewOverviewCardSeenEventActivitiesFieldsV1,
} from '@agoda/analytics-messages-definition-activities/events.split';
import {
    ActivitiesMiniReviewContentRevealEventActivitiesManifestV1,
    ActivitiesReviewCardClickEventActivitiesManifestV1,
    ActivitiesReviewOverviewCardSeenEventActivitiesManifestV1,
} from '@agoda/analytics-messages-definition-activities/manifest/events';

import { InView } from 'react-intersection-observer';

interface OwnProps {
    index: number;
    review: ReviewCardProps;
    recentReview?: boolean;
}

type Props = OwnProps;

const ELLIPSIS = '...';
const MAX_MIN_REVIEW_TEXT_LENGTH = 80;

const ReviewCardMinimal: React.FC<Props> = (props) => {
    const { recentReview, review } = props;
    if (!review) return null;

    const onSeen = (inView: boolean) => {
        if (!inView) return;
        trackElementEvent<ActivitiesReviewOverviewCardSeenEventActivitiesFieldsV1>(
            ActivitiesReviewOverviewCardSeenEventActivitiesManifestV1.ids,
            {},
            { action_element_index: props.index + 1, action_element_value: review.id.toString() },
        );
        if (recentReview) {
            trackElementEvent<ActivitiesMiniReviewContentRevealEventActivitiesFieldsV1>(ActivitiesMiniReviewContentRevealEventActivitiesManifestV1.ids, {});
        }
    };

    const onClick = () => {
        if (!recentReview) {
            trackElementEvent<ActivitiesReviewCardClickEventActivitiesFieldsV1>(ActivitiesReviewCardClickEventActivitiesManifestV1.ids, {
                is_modal: false,
            });
        }
    };

    const reviewDescription = review.description.substring(0, MAX_MIN_REVIEW_TEXT_LENGTH).concat(ELLIPSIS);
    const height = recentReview ? '100%' : '200px';
    const minWidth = recentReview ? 'none' : '280px';
    const width = recentReview ? '300px' : 'none';
    return (
        <>
            {/* eslint-disable-next-line @agoda/agoda-a11y/no-incorrect-props, @agoda/agoda-a11y/no-incorrect-drone-box-usage -- @agoda/agoda-a11y/no-incorrect-props[d2860743-51bf-43c0-946f-f1f4a9b12864], @agoda/agoda-a11y/no-incorrect-drone-box-usage[6db31b32-84c0-492a-a2c3-beec0cc03787] */}
            <Box
                data-element-name="activities-mini-review-content"
                data-testid="activities-mini-review-content"
                p="12"
                data-elment-index={props.index}
                borderStyle="solid"
                borderWidth="1"
                borderRadius="16"
                borderColor="base.default"
                height={height}
                minWidth={minWidth}
                width={width}
                onClick={onClick}
            >
                <InView onChange={onSeen} triggerOnce={true} threshold={1}>
                    <ReviewCardTitle minimal={true} recentReview={recentReview} reviewTitle={review.title} reviewScore={review.score} reviewSource={review.source} />
                    {review.description && (
                        <Typography tag="span" variant="body-s" textColor="base.default" mt="8" lineClamp={recentReview ? 4 : undefined}>
                            <AgodaMarkdown input={recentReview ? review.description : reviewDescription} overrides={{ p: { component: Typography, props: { mb: '0' } } }} />
                        </Typography>
                    )}
                    {!recentReview && review.authorName && (
                        <Typography tag="p" variant="caption-default-strong" textColor="base.subtle" mt="12">
                            {review.authorName}
                        </Typography>
                    )}
                </InView>
            </Box>
        </>
    );
};

ReviewCardMinimal.displayName = 'ReviewCardMinimal';

export default ReviewCardMinimal;
